import { Component, OnInit, signal } from '@angular/core';
import { IMPORTS } from './_imports';
import { DashboardTab } from '../../models/dashboard.model';
import { AuthService } from '../../services/auth.service';
import { Enums } from '../../shared/enums';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    standalone: true,
    imports: IMPORTS,
})
export class DashboardComponent implements OnInit {
    // #region [signals]
    $activeTab = signal('available-flow-definitions' as DashboardTab);
    // #endregion

    // #region [props]
    isAdminAll = false;
    // #endregion

    constructor(private authService: AuthService) {
        if (this.authService.hasProfiles([Enums.Profiles.AdminAll])) {
            this.isAdminAll = true;
        } else {
            this.$activeTab.set('flow-instances-by-inbox');
        }
    }

    ngOnInit() { }

    // #region [===== private methods =====]
    // #endregion
}
